/* eslint-disable */
export const isBrowser = typeof window !== "undefined";

export const isEDMode =
  typeof window !== "undefined"
    ? window.location.href.indexOf("ed=1") > 0
    : false;

export const setSessionStorage = (key, value) => {
  if (!isBrowser || !key) return false;

  try {
    const serializedValue = JSON.stringify(value);
    sessionStorage.setItem(key, serializedValue);
    return true;
  } catch (error) {
    console.error('Failed to write to sessionStorage:', error);
    return false;
  }
};

export const getSessionStorage = (key) => {
  if (!isBrowser || !key) return null;

  try {
    const value = sessionStorage.getItem(key);
    if (!value) return null;
    
    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  } catch (error) {
    console.error('Failed to read from sessionStorage:', error);
    return null;
  }
};